import { render, staticRenderFns } from "./IconMealPlanLinear.vue?vue&type=template&id=d4a1808c&scoped=true"
import script from "./IconMealPlanLinear.vue?vue&type=script&lang=js"
export * from "./IconMealPlanLinear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a1808c",
  null
  
)

export default component.exports